import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import { withTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import s from './Login.css';
import Link from '../../components/Link';
import { useLoginLogic } from './Login.functions';

/**
 * Composant Login - Page de connexion utilisateur
 * 
 * @component
 * @param {Object} props - Props du composant
 * @param {Function} props.t - Fonction de traduction
 * @returns {JSX.Element} Composant de connexion
 */
const Login = ({ t }) => {
  const { state, handlers } = useLoginLogic({ t });

  return (
    <div className={s.root}>
      <div className={s.container}>
        <h1>{t("login.title")}</h1>
        <form method="post" onSubmit={handlers.handleLogin}>
          {state.err && (
            <div className={s.error}>
              {t("login.errorauthentification")}
            </div>
          )}
          <div className={s.formGroup}>
            <label className={s.label} htmlFor="email">
              <input
                className={s.input}
                id="email"
                type="text"
                name="email"
                autoFocus // eslint-disable-line jsx-a11y/no-autofocus
                placeholder={t("login.form.email")}
                value={state.email}
                onChange={handlers.handleFieldChange('email')}
                disabled={state.loading}
              />
            </label>
          </div>
          <div className={s.formGroup}>
            <label className={s.label} htmlFor="password">
              <input
                className={s.input}
                id="password"
                type="password"
                name="password"
                placeholder={t("login.form.password")}
                value={state.password}
                onChange={handlers.handleFieldChange('password')}
                disabled={state.loading}
              />
            </label>
          </div>
          <div className={s.formFooter}>
            <div className={s.formAction}>
              <button 
                className={s.button_prim} 
                type="submit"
                disabled={state.loading}
              >
                {state.loading ? t("login.form.loading") : t("login.form.validate")}
              </button>
            </div>
            <div className={s.mt_xl}>
              <Link className={s.link} to="/forgot">
                {t("login.form.forgot")}
              </Link>
            </div>
            <div className={s.mt_l}>
              <Link className={s.link} to="/register">
                {t("login.form.register")}
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

Login.propTypes = {
  t: PropTypes.func.isRequired
};

export default withTranslation()(withStyles(s)(Login));